import React from "react";
import {
  SimpleGrid,
  IconButton,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
import { FaTiktok, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa";

/**
 * Two‑column grid of round social / contact icons, shown only on mobile.
 * Usage: <MobileSocialIcons />  (put it anywhere you need it)
 */
const MobileSocialIcons = () => {
  const icons = [
    {
      href: "https://mail.google.com/mail/?view=cm&fs=1&to=info@nomad360.io",
      label: "Contact us",
      icon: <EmailIcon />,
    },
    {
      href: "https://www.tiktok.com/@nomad360.io",
      label: "TikTok",
      icon: <FaTiktok />,
    },
    {
      href: "https://www.instagram.com/nomad360.io/",
      label: "Instagram",
      icon: <FaInstagram />,
    },
    {
      href: "https://youtube.com/@nomad360io",
      label: "YouTube",
      icon: <FaYoutube />,
    },
    {
      href: "https://www.linkedin.com/company/nomad360-io",
      label: "LinkedIn",
      icon: <FaLinkedin />,
    },
  ];

  return (
    <SimpleGrid
      columns={2}
      spacing={2}
      mt={3}
      display={{ base: "grid", md: "none" }} // mobile only
      w="70%"
      placeItems="left"
    >
      {icons.map(({ href, label, icon }) => (
        <IconButton
          key={label}
          as={ChakraLink}
          href={href}
          aria-label={label}
          icon={icon}
          isRound
          boxSize="38px"
          bg="blackAlpha.100"
          _hover={{ bg: "blackAlpha.200" }}
          target="_blank"
          rel="noopener noreferrer"
        />
      ))}
    </SimpleGrid>
  );
};

export default MobileSocialIcons;
